import {state as lifecycle} from 'fragments/lifecycle';

export default {
	...lifecycle,
	initialized: false,
	loading: false,
	csvImport: null,
	isEditModalOpen: false,
};
